module.exports = __webpack_public_path__ + "static/media/menu-close.621b993f.svg";